import classNames from 'classnames';
import React, { useState } from 'react';
import Typography from '@/components/atoms/typography/typography';
import ConfigurationFlowPaxModal from '@/components/modules/configuration-flow/configuration-flow-pax-modal/configuration-flow-pax-modal';
import { getPaxInfo } from '@/components/modules/configuration-flow/configuration-flow-utils';
import Link from '@/components/utilities/link/link';
import { useI18n } from '@/libraries/contexts/i18n-context';
import styles from './configuration-flow-pax-selector.module.scss';

export interface ConfigurationFlowPaxSelectorProps {
  /** Additional class names */
  className?: string;
  /** Search settings for the search bar */
  searchSettings: Content.Components['SearchSettingsDto'];
}

const ConfigurationFlowPaxSelector = ({
  className,
  searchSettings,
}: ConfigurationFlowPaxSelectorProps) => {
  const { t } = useI18n();
  const [isPaxModalOpen, setIsPaxModalOpen] = useState(false);

  return (
    <React.Fragment>
      <div className={classNames(styles.component, className)}>
        <Typography className={styles.paxInfo} tagStyle="bodyMediumBold">
          {`${t('items.modules.configurationFlow.resultsAreFor')} ${getPaxInfo({ searchSettings, t })}`}
        </Typography>

        <Link className={styles.link} onClick={() => setIsPaxModalOpen(true)}>
          <Typography tagStyle="bodyMedium">
            {t('items.common.words.edit')}
          </Typography>
        </Link>
      </div>

      <ConfigurationFlowPaxModal
        key={JSON.stringify(searchSettings)}
        isOpen={isPaxModalOpen}
        searchSettings={searchSettings}
        setIsOpen={value => setIsPaxModalOpen(value)}
      />
    </React.Fragment>
  );
};

ConfigurationFlowPaxSelector.displayName = 'ConfigurationFlowPaxSelector';

export default ConfigurationFlowPaxSelector;
